<mat-form-field class="form-field" [formGroup]="group" [ngStyle]="field.containerStyles" [color]="field.color">
  <mat-label *ngIf="field.label" [innerHTML]="field.label | gioNoSanitize"></mat-label>
  <mat-select [gioEnableControl]="isEnabledFn(field.name, field.id)" [ngStyle]="field.selectStyles"
    [required]="field.required" [multiple]="field.multi" [placeholder]="field.placeholder"
    [formControlName]="field.name">

    <ng-container *ngIf="field.options">
      <mat-option *ngFor="let item of field.options" [value]="item.id">{{item.value}}</mat-option>
    </ng-container>

    <ng-container *ngIf="field.groups">

      <mat-optgroup *ngFor="let group of field.groups" [label]="group.name">
        <mat-option *ngFor="let item of group.options" [value]="item.id">
          {{item.value}}
        </mat-option>
      </mat-optgroup>


    </ng-container>


  </mat-select>
</mat-form-field>
